import React from 'react'
import Table from '@/components/table/Table'
import Row from '@/components/table/Row'
import Paper from '@mui/material/Paper'
import { useLazyGetUserQuery } from '@/store/apis/users'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

const UserSchemaSelector: React.FC = () => {
  const { t } = useTranslation('default')
  const navigate = useNavigate()
  const [getUserQuery, { data: userData, isFetching: isGettingUser }] =
    useLazyGetUserQuery()
  const schemaIds = JSON.parse(localStorage.getItem('schemaIds'))

  React.useEffect(() => {
    if (schemaIds.length === 1) {
      navigate(`/schema/${schemaIds[0]}/schema`)
    }
    getUserQuery({ id: Number(localStorage.getItem('userId')) })
  }, [getUserQuery])

  return (
    <>
      {schemaIds.length ? (
        <Table headerLabels={[t('headers.name')]} isLoading={isGettingUser}>
          {userData?.schemas.map((schema, index) => (
            <Row
              key={index}
              navigateTo={`/schema/${schema.id}`}
              columns={{
                normal: [schema.name, ''],
              }}
            />
          ))}
        </Table>
      ) : (
        <Paper
          variant="elevation"
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: 5,
          }}
        >
          {t('noSchema')}
        </Paper>
      )}
    </>
  )
}

export default UserSchemaSelector
